module.exports = __webpack_public_path__ + "static/img/hs_bot2.a3e8782.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/chanpin/hs_bot2.png
// module id = XgcA
// module chunks = 1